import OnlinePaymentTransactionProcessingResourceModel from '../../generated/types/model/resource/OnlinePaymentTransactionProcessingResourceModel';

export default class OnlinePaymentTransactionProcessingResourceViewModel extends OnlinePaymentTransactionProcessingResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
